export function helperBackgroundimageRounder() {
    window.addEventListener('resize', function () {
        append_css_variables()
    })

    append_css_variables();
}

function append_css_variables() {
    document.querySelectorAll('.is-style-right-circle .header_image, .is-style-left-circle .header_image, .download-block .header_image').forEach((container) => {
        let parentSection = container.closest('section'),
            parentSectionHeight = parentSection.offsetHeight,
            image_container = container.offsetHeight,
            image = container.querySelector('img');

        if(!image){
            return false;
        }


        container.style.setProperty('--header-top', (container.parentElement.offsetHeight - image_container)/2 + 'px');
        image.style.setProperty('--image-height', parentSectionHeight + 'px');
    })
}